import QuillEditor from "@components/CreateQuestion/Question/QuillEditor";
import { Controller } from "react-hook-form";

const Description: React.FC<any> = ({ errors, control }) => {
  return (
    <div className="w-[80%] self-end">
      <div style={{ position: "relative" }} className="w-[80%] mt-5">
        <Controller
          name="jobDescription"
          rules={{
            required: "This field is required.",
          }}
          control={control}
          render={({ field: { value, onChange } }) => (
            <QuillEditor
              label="Job Description"
              required
              value={value}
              onChange={onChange}
            />
          )}
        />
        {errors["jobDescription"]?.message && (
          <span className="whitespace-pre text-xs mt-2 text-orange-700">
            {errors["jobDescription"]?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default Description;
